<template lang="pug">
<svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.495 5.07071C16.534 4.79734 16.3441 4.54408 16.0707 4.50503C15.7973 4.46597 15.5441 4.65592 15.505 4.92929L16.495 5.07071ZM15 12V12.5H15.4336L15.495 12.0707L15 12ZM3.49994 12L3.01104 12.1048L3.09573 12.5H3.49994V12ZM2.4889 4.89524C2.43104 4.62523 2.16525 4.45324 1.89524 4.5111C1.62523 4.56896 1.45324 4.83475 1.5111 5.10476L2.4889 4.89524ZM15.505 4.92929L14.505 11.9293L15.495 12.0707L16.495 5.07071L15.505 4.92929ZM15 11.5H3.49994V12.5H15V11.5ZM3.98884 11.8952L2.4889 4.89524L1.5111 5.10476L3.01104 12.1048L3.98884 11.8952Z" fill="currentColor"/>
    <path d="M13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5" stroke="currentColor"/>
    <path d="M0 4.5H18" stroke="currentColor"/>
</svg>
</template>

<script>
export default {
  name: 'CartIcon'
}
</script>

<style scoped>
svg{
  width:22px;
  height:16px;
}
</style>
